import React, {Component} from 'react';
import {Field, reduxForm} from 'redux-form';
import {connect} from 'react-redux';
import {forgotPassword} from '../../actions/Index';
import {renderEmailInputField} from '../Layout/FormInputs'
import {toastr} from "react-redux-toastr";
import {langs} from '../../config/localization';
import {updateUserDetailsLocalStorage} from "../../actions/Common";
import {Loader} from "../Common/Loader";

class ForgotPassword extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showLoader      : false        
        };
    }
    /**
     * Submit forgot password form
     * @param values
     */
    onSubmit(values){
        this.setState({ showLoader: true });
        //Call the forgot password action
        this.props.forgotPassword(values, (response)=>{
            if(response != undefined){
                this.setState({ showLoader: false });
                if(response.status == 200) {

                    //On successful forgot request redirect user to reset password page
                    toastr.success(langs.success, response.data.message);
                    //Delay the page redirection for 1 second to show toastr message
                    setTimeout(function () {
                        window.location.assign('/login');
                    }.bind(this), 3000);
                } else {
                    //Show default error response
                    toastr.error(langs.error, langs.messages.default_error);
                }
            }
        });
    }

    /**
     * Render the reset password form
     * @returns {*}
     */
     render(){
         const {handleSubmit} = this.props;
         if(!this.state.showLoader) {
             return (
                 <section className="section-login">
                     <div className="row">
                         <div className="medium-12 columns">
                             <div className="login-wrapper">
                                 <div className="login-container">
                                     <div className="login-left primary-gradient-bg">
                                         <div className="globe-bg">
                                             <h2>Welcome to earthDECKS</h2>
                                         </div>
                                         <div className="map-bg">
                                                <img src="assets/images/eathdeck/map.png" />
                                            </div>
                                     </div>
                                     <div className="login-right">
                                         <h1>Forgot Password</h1>
                                         <div className="icon-form text-center">
                                            <img src="assets/images/eathdeck/Forgot Password.png" />
                                        </div>
                                         <form noValidate className="form" onSubmit={handleSubmit(this.onSubmit.bind(this))}>
                                           <div className="login-form">
                                               <div className="form-group email">
                                                   <label>{langs.forgot_email_address}*</label>
                                                   {/*<input type="text" className="form-control email" />*/}
                                                   <Field
                                                       name="email"
                                                       component={renderEmailInputField}
                                                       className=""
                                                   />
                                               </div>

                                               <div className="form-group text-center">
                                                   {/*<a href="#" className="btn-primary primary-gradient-bg">LOGIN</a>*/}
                                                   <button type="submit" className="btn-primary primary-gradient-bg">
                                                       <span>EMAIL PASSWORD</span>
                                                   </button>
                                               </div>
                                           </div>
                                         </form>
                                     </div>
                                 </div>
                             </div>
                         </div>
                     </div>
                 </section>
             );
            } else {
                return <Loader loaderContent='form-submission' />
            }
     }
}

/**
 * Form Validations
 * @param values
 * @returns {{}}
 */
function validate(values){
    let errors = {};

    if(!values.email){
        errors.email = langs.validation_messages.email_required;
    }

    if(values.email && /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(values.email) == false){
        errors.email = langs.validation_messages.email_pattern;
    }

    return errors;
}

export default reduxForm({
    validate,
    form: 'ForgotPassword'
})(
    connect(null, {forgotPassword})(ForgotPassword)
);



// WEBPACK FOOTER //
// ./components/Auth/ForgotPassword.js